<mat-calendar #tdcalendar [(selected)]="selectedDate" [dateFilter]="filterDate" [startAt]="startAt" [minDate]="minDate"
    [headerComponent]="customHeader" [maxDate]="maxDate" [dateClass]="setDateClass()" [ngClass]="identifier"
    (selectedChange)="dateChange($event)">
</mat-calendar>